import React, { useEffect, useState } from 'react'
import { motion } from "framer-motion";
import { client } from "../client";

function Experience() {
    const [experience, setExperience] = useState([]);

    useEffect(() => {
        const query = '*[_type == "experience"] | order(order desc)'

        client.fetch(query).then((experience) => setExperience(experience));
    }, []);
    return (
        <div id="experience" className="h-full !pt-12">
            <motion.div
                whileInView={{ y: [50, 0], opacity: [0, 1] }}
                transition={{ duration: 1, ease: "easeInOut" }}
                className="p-3 md:p-10 w-full text-center">
                <center>
                    <div className="w-fit font-mono font-extrabold text-transparent text-4xl md:text-5xl bg-clip-text bg-gradient-to-r from-[#00c3ff] to-[#ffff1c]">
                        Experience
                    </div>
                    <br />
                    <br />
                    <div className="flex flex-col gap-10 p-2 max-w-2xl justify-center overflow-hidden">
                        {experience.map((experience, index) => (
                            <div className='text-left grid md:grid-cols-3'>
                                <motion.div
                                    whileInView={{ x: [-100, 0], opacity: [0, 1] }}
                                    transition={{ duration: 1, ease: "easeInOut" }}
                                    className='col-span-1 md:p-2'>{experience.duration}</motion.div>
                                <motion.div
                                    whileInView={{ x: [100, 0], opacity: [0, 1] }}
                                    transition={{ duration: 1, ease: "easeInOut" }} className='col-span-2 flex flex-col gap-2'>
                                    <div className='flex items-end gap-2'>
                                        <div className='text-2xl font-bold'>{experience.company}</div>
                                        <div className='font-extralight'> | {experience.role}</div>
                                    </div>
                                    <div>{experience.description.split('\n').map((line, index) => (
                                        <React.Fragment key={index}>
                                            {line}
                                            {index < experience.description.split('\n').length - 1 && <br />}
                                        </React.Fragment>
                                    ))}</div>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </center>
            </motion.div>
        </div>
    )
}

export default Experience